import React, { useEffect, useRef, useState } from "react";
import { FaRegCreditCard } from "react-icons/fa6";
import { useStores } from "../../store";
import { useObserver } from "mobx-react";
import ReactPaginate from "react-paginate";
import LoadingAnime from "../reusble_components/loadingAnime";
import { AiOutlineSearch } from "react-icons/ai";
import TotalCredits from "../reusble_components/profile/totalcredits";
import { MdOutlineAccessTime } from "react-icons/md";

let shimmer = {
  numRows: 5,
  rowHeight: "4rem",
  bgColor: "bg-gray-100",
  showProfilePic: true,
  page: "",
  headerTitles: [
    { name: "Profile pic", width: "5%" },
    { name: "Name", width: "15%" },
    { name: "Email ID", width: "20%" },
    { name: "Applied date", width: "15%" },
    { name: "Applied for", width: "15%" },
    { name: "Total Score", width: "10%" },
    { name: "Status", width: "10%" },
  ],
  rowBoxes: [
    {
      width: "15%",
      height: "1.2rem",
      shape: "rectangle",
    },
    {
      width: "20%",
      height: "1.2rem",
      shape: "rectangle",
    },
    {
      width: "15%",
      height: "1.2rem",
      shape: "rectangle",
    },
    {
      width: "15%",
      height: "1.2rem",
      shape: "rectangle",
    },
    {
      width: "10%",
      height: "1.2rem",
      shape: "rectangle",
    },
    {
      width: "10%",
      height: "1.2rem",
      shape: "rectangle",
    },
  ],
};

const data = [
  {
    pic: "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png",
    name: "Balla Aravindh",
    date: "30 jun 2024",
    id: "ML intern",
    credits: 100,
    reason: "HR interview",
    type: "interview",
  },
  {
    pic: "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png",
    name: "Balla Aravindh",
    date: "30 jun 2024",
    id: "ML intern",
    credits: 100,
    reason: "Technical interview",
    type: "interview",
  },
  {
    pic: "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png",
    name: "Balla Aravindh",
    date: "30 jun 2024",
    id: "ML intern",
    credits: 100,
    reason: "Redeem",
    type: "redeem",
  },
  // Add more applicant data as needed
];

const calculateUsedCredits = (data) => {
  return data.reduce((acc, item) => {
    return item.type === "interview" ? acc + item.credits : acc;
  }, 0);
};

const totalCredits = "-"; // Assuming total credits is a fixed value
const usedCredits = "-"; //calculateUsedCredits(data)
const remainingCredits = totalCredits - usedCredits;

const Card = ({ title, value, color }) => (
  <div className="flex items-center justify-between p-4 bg-white rounded-lg shadow-lg w-full max-w-sm md:max-w-md lg:max-w-lg">
    <div>
      <div className="flex items-center">
        <FaRegCreditCard className={`text-2xl mr-2 ${color}`} />
        <h3 className="text-lg font-semibold text-gray-800">{title}</h3>
      </div>
      <p className={`text-3xl mt-2 ml-7 font-bold ${color}`}>{value}</p>
    </div>
  </div>
);

export const Table = ({ data }) => {
  const { UserStore } = useStores();
  const [currentPage, setCurrentPage] = useState(0);

  const handlePageClick = (page) => {
    UserStore.getTransactions({ skip: page.selected * 10 });
    setCurrentPage(page.selected);
  };
  function timestampToDate(timestamp) {
    const date = new Date(timestamp);
    if (isNaN(date.getTime())) {
      return "Invalid Date";
    }
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  }
  const [filters, setFilters] = useState({
    search: "",
  });
  return (
    <>
      {UserStore.loader}
      <div className="mb-10">
        <div className="overflow-x-auto">
          <table className="hidden md:table lg:table min-w-full mt-2 md:mt-2 lg:mt-3 bg-white">
            <thead className="bg-[#FEEFD6]  h-14 rounded-lg">
              <tr className=" md:table-row lg:table-row">
                {/* <th className="py-2 text-center font-medium rounded-s-xl text-[#121212] text-sm md:text-base">
                  Name
                </th> */}
                <th className="py-2 font-medium text-sm md:text-base">Date</th>
                <th className="py-2 font-medium text-sm md:text-base">
                  Transaction ID
                </th>
                <th className="py-2 font-medium text-sm md:text-base">
                  Credit Usage
                </th>
                <th className="py-2 font-medium text-sm md:text-base">
                  Reason
                </th>
                <th className="py-2 font-medium rounded-r-lg text-sm md:text-base">
                  Status
                </th>
              </tr>
            </thead>
            <tbody>
              {UserStore.transactions?.transactions?.length === 0 && (
                <tr>
                  <td colSpan="6" className="text-center text-2xl h-20 py-2">
                    No transactions found
                  </td>
                </tr>
              )}
              {UserStore.transactions?.transactions ? (
                <>
                  {UserStore.transactions?.transactions?.map(
                    (applicant, index) => (
                      <tr
                        key={index}
                        className="border-b text-center justify-center md:h-fit lg:h-fit h-[20vh] text-[#717171]  px-5 text-sm md:text-base"
                      >
                        {/* <td className="py-3 px-2">{applicant?.userId?.name}</td> */}
                        <td className="py-5 px-2">
                          {timestampToDate(applicant?.createdAt)}
                        </td>
                        <td className="py-3 px-2 w-[8rem] truncate overflow-hidden text-ellipsis">
                          {applicant._id}
                        </td>
                        <td className="py-3 px-2">
                          <span
                            className={
                              applicant.type === "credit"
                                ? "text-green-500"
                                : "text-red-500"
                            }
                          >
                            {applicant.type === "credit"
                              ? `+${applicant.amount}`
                              : `-${applicant.amount}`}
                          </span>
                        </td>
                        <td className="py-3 px-2">{applicant.reason}</td>
                        <td className="py-3 px-2">
                          <span
                            className={
                              applicant.status === "success"
                                ? "text-green-500"
                                : "text-red-500"
                            }
                          >
                            {applicant.status}
                          </span>
                        </td>
                      </tr>
                    )
                  )}
                </>
              ) : (
                <>
                  {Array.from({ length: shimmer.numRows }).map((_, index) => (
                    <tr
                      key={index}
                      className={`${shimmer.bgColor} animate-pulse border-b text-center justify-center md:h-fit lg:h-fit h-[20vh] text-[#717171] px-5 text-sm md:text-base`}
                      style={{ height: shimmer.rowHeight }}
                    >
                      {Array.from({ length: 5 }).map((_, idx) => (
                        <td key={idx} className="py-3 px-2">
                          <div
                            className={`bg-gray-300 rounded-md mx-2 animate-pulse`}
                            style={{ width: "100px", height: "20px" }}
                          ></div>
                        </td>
                      ))}
                    </tr>
                  ))}
                </>
              )}
            </tbody>
          </table>
        </div>
        {UserStore.transactions?.transactions?.length === 0 && (
          <tr className="md:hidden lg:hidden">
            <td colSpan="6" className="text-center text-2xl h-20 py-2">
              No transactions found
            </td>
          </tr>
        )}
        {/* {!UserStore.transactions?.totalCredits != null && (
          <div className="mt-5 space-y-4">
            {Array.from({ length: shimmer.numRows }).map((_, index) => (
              <div
                key={index}
                className={`${shimmer.bgColor} flex items-center rounded-lg py-3 px-5 shadow-md animate-pulse`}
                style={{ height: shimmer.rowHeight }}
              >
                <div className="flex-1 ml-4 flex w-full justify-around">
                  {shimmer.rowBoxes.map((rowBox, idx) => (
                    <div
                      key={idx}
                      className={`bg-gray-300 ${
                        rowBox.shape === "rectangle"
                          ? "rounded-md"
                          : "rounded-full"
                      } mx-2 animate-pulse`}
                      style={{
                        width: rowBox.width,
                        height: rowBox.height,
                      }}
                    ></div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )} */}
        {UserStore.transactions?.transactions?.map((applicant) => (
          <div
            key={applicant._id}
            className="md:hidden lg:hidden bg-white p-3 mb-3 h-[15%] flex-wrap rounded-lg shadow-lg flex flex-col gap-0"
          >
            <div className="flex  ">
              <h1>{applicant.reason}</h1>
              <h1 className="ml-auto text-[20px] font-bold">
                <span
                  className={
                    applicant.type === "credit"
                      ? "text-green-500"
                      : "text-red-500"
                  }
                >
                  {applicant.type === "credit"
                    ? `+${applicant.amount}`
                    : `-${applicant.amount}`}
                </span>
              </h1>
            </div>

            <h1 className="text-base text-[#717171] ">
              {applicant?.userId?.name}
            </h1>

            <h1> </h1>
            <div className="flex mt-4  text-[#717171] ">
              <h1 className="text-xs ">id:{applicant._id}</h1>
              <h1 className="flex justify-center items-center text-xs ml-auto">
                <MdOutlineAccessTime className="text-[12px]" />
                {timestampToDate(applicant?.createdAt)}
              </h1>
            </div>

            {/* <h1>
              <span
                className={
                  applicant.status === "success"
                    ? "text-green-500"
                    : "text-red-500"
                }
              >
                {applicant.status}
              </span>
            </h1> */}
          </div>
        ))}
        {/* {UserStore.transactions.count > 10 && (
          <div>
            <ReactPaginate
              nextLabel=" >"
              className="flex justify-center items-center gap-5 my-4"
              onPageChange={handlePageClick}
              pageRangeDisplayed={3}
              marginPagesDisplayed={2}
              pageCount={UserStore.transactions.count / 10}
              previousLabel="< "
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              breakLabel="..."
              breakClassName="page-item"
              breakLinkClassName="page-link"
              containerClassName="pagination"
              activeClassName="active-page-item"
              activeLinkClassName="active-page-link"
              renderOnZeroPageCount={null}
            />
          </div>
        )} */}
        {UserStore.transactions.count > 10 && (
          <div className="">
            <ReactPaginate
              nextLabel={
                currentPage < Math.ceil(UserStore.transactions.count / 10) - 1
                  ? " >"
                  : null
              }
              className="flex justify-center items-center gap-5 my-4"
              onPageChange={handlePageClick}
              pageRangeDisplayed={3}
              marginPagesDisplayed={2}
              pageCount={UserStore.transactions.count / 10}
              previousLabel={currentPage > 0 ? "<" : null} // Conditionally render the previous label
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              breakLabel="..."
              breakClassName="page-item"
              breakLinkClassName="page-link"
              containerClassName="pagination"
              activeClassName="active-page-item"
              activeLinkClassName="active-page-link"
              renderOnZeroPageCount={null}
            />
          </div>
        )}
      </div>
    </>
  );
};

const ViewCredits = ({ availableCredits }) => {
  const { UserStore, RecuiterStore } = useStores();
  // const [isExpanded, setIsExpanded] = useState(false);
  const inputRef = useRef(null);
  const totalcredits = availableCredits;

  // const handleSearchClick = () => {
  //   setIsExpanded(true);
  // };

  // useEffect(() => {
  //   if (isExpanded && inputRef.current) {
  //     inputRef.current.focus();
  //   }
  // }, [isExpanded]);

  const handleSearch = (value) => {
    if (value) {
      UserStore.getTransactions({ transactionId: value });
    } else {
      UserStore.getTransactions({});
      // setIsExpanded(false); // Collapse after search
    }
  };

  const handleInputChange = (e) => {
    if (e.target.value.length === 0) {
      UserStore.getTransactions({});
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearch(e.target.value);
    }
  };

  useEffect(() => {
    if (RecuiterStore.refreshObject.settings === 0) {
      UserStore.getTransactions({});
      RecuiterStore.refreshObject.settings = 1;
    }
  }, []);

  const [coins, setcoins] = useState(0);

  // useEffect(() => {
  //   // const userDetails = JSON.parse(localStorage.getItem("user"));
  //   const localCoins = UserStore.userDetails?.coins ?? availableCredits;

  //   setcoins(localCoins);
  // }, [UserStore.userDetails?.coins]);
  console.log(RecuiterStore.loader);

  return useObserver(() => (
    <>
      <div className="pb-8    flex flex-col mt-6 bg-white min-h-screen md:mb-5 gap-5 lg:mb-5  ">
        {/* <div className="flex justify-end items-center ">
          <button
            className="px-3 py-1 bg-primary rounded-md text-white"
            onClick={() => UserStore.getTransactions()}
          >
            Refresh
          </button>
        </div> */}
        {/* <h1 className="text-xl md:text-xl lg:text-2xl font-semibold mt-3 ml-[10%] md:ml-0 mb-8">Credit Points</h1> */}
        {/* <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-4 mb-8 h-32">
          <Card
            title="Total Credits"
            value={
              UserStore.transactions?.totalCredits != null ? (
                UserStore.transactions.totalCredits
              ) : (
                <LoadingAnime
                  page={"applicants"}
                  numBoxes={1}
                  boxWidth="4rem"
                  boxHeight="3rem" // Adjust height as needed for a rectangle
                  gridColumns="grid-cols-1"
                  bgColor="bg-gray-200"
                  innerBoxes={[]} // No inner boxes needed
                />
              )
            }
            color="text-blue-500"
          />
          <Card
            title="Used Credits"
            value={
              UserStore.transactions?.usedCredits != null ? (
                UserStore.transactions.usedCredits
              ) : (
                <LoadingAnime
                  page={"applicants"}
                  numBoxes={1}
                  boxWidth="4rem"
                  boxHeight="3rem" // Adjust height as needed for a rectangle
                  gridColumns="grid-cols-1"
                  bgColor="bg-gray-200"
                  innerBoxes={[]} // No inner boxes needed
                />
              )
            }
            color="text-red-500"
          />
          <Card
            title="Remaining Credits"
            value={
              UserStore.transactions?.usedCredits != null ? (
              UserStore.transactions?.usedCredits != null ? (
                UserStore.userDetails?.coins ?? availableCredits
              ) : (
                <LoadingAnime
                  page={"applicants"}
                  numBoxes={1}
                  boxWidth="4rem"
                  boxHeight="3rem" // Adjust height as needed for a rectangle
                  gridColumns="grid-cols-1"
                  bgColor="bg-gray-200"
                  innerBoxes={[]} // No inner boxes needed
                />
              )
            }
            color="text-green-500"
          />
        </div> */}
        <TotalCredits
          totalCredits={
            UserStore.transactions?.totalCredits != null ? (
              UserStore.transactions.totalCredits
            ) : (
              <LoadingAnime
                page={"applicants"}
                numBoxes={1}
                boxWidth="4rem"
                boxHeight="3rem" // Adjust height as needed for a rectangle
                gridColumns="grid-cols-1"
                bgColor="bg-gray-200"
                innerBoxes={[]} // No inner boxes needed
              />
            )
          }
          usedCredits={
            UserStore.transactions?.usedCredits != null ? (
              UserStore.transactions.usedCredits
            ) : (
              <LoadingAnime
                page={"applicants"}
                numBoxes={1}
                boxWidth="4rem"
                boxHeight="3rem" // Adjust height as needed for a rectangle
                gridColumns="grid-cols-1"
                bgColor="bg-gray-200"
                innerBoxes={[]} // No inner boxes needed
              />
            )
          }
          remainingCredits={
            UserStore.transactions?.usedCredits != null ? (
              UserStore.userDetails?.coins ?? availableCredits
            ) : (
              <LoadingAnime
                page={"applicants"}
                numBoxes={1}
                boxWidth="4rem"
                boxHeight="3rem" // Adjust height as needed for a rectangle
                gridColumns="grid-cols-1"
                bgColor="bg-gray-200"
                innerBoxes={[]} // No inner boxes needed
              />
            )
          }
        />
        {/* <Loader loader={UserStore.loader} /> */}
        {/* <div className="flex  mt-5 items-center  "> */}
        <div className=" flex mt-5 items-center justify-between lg:pr-5">
          <p className="text-[#000000] font-semibold text-lg md:text-xl lg:text-xl whitespace-nowrap">
            Transaction History
          </p>
          {/* <div
        className="flex justify-between items-center mt-2  ml-56 rounded-2xl border-2 border-primary"
        style={{ boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)" }}
      >
        <input
          name="search"
          type="text"
          placeholder="Search by name,label...."
          className=" placeholder-gray-400  border-none w-full truncate text-md md:text-lg  rounded-l-2xl h-10  md:w-[95%]"
          // onKeyPress={handleKeyPress}
        />
        <CiSearch className="md:text-4xl lg:text-4xl text-2xl text-primary  md:right-6 " />
      </div> */}

          <div className=" tc1:hidden sm:block sm:flex pl-3 pr-3 py-1 items-center border border-[#FF6B00] rounded-lg md:pl-5 md-pr-5 lg:pl-5 lg:pr-5 ">
            {/* <ApplicantSearch /> */}
            <input
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  // alert(e.target.value);
                  UserStore.getTransactions({ transactionId: e.target.value });
                }
              }}
              onChange={(e) => {
                if (e.target.value.length === 0) {
                  UserStore.getTransactions({});
                }
              }}
              type="text"
              placeholder="Search by ID"
              className=" md:w-fit lg:w-fit text-xs md:text-sm lg:text-sm w-[90%] h-7 border-none outline-none rounded-l-md"
            />

            <AiOutlineSearch className="md:text-xl sm:text-lg items-center justify-center text-[#FF6B00]" />
          </div>

          {/* <button
                className=" hidden px-3 py-1 border  border-primary text-primary rounded-md flex justify-center items-center gap-2 "
                onClick={() => {
                  UserStore.transactions = null;
                  UserStore.getTransactions({});
                }}
              >
                <AiOutlineRedo />
                Refresh
              </button> */}

          {/* <button className="hidden  flex items-center  justify-center ml-8 text-primary font-extrabold">
              View More{" "}
              <span className="  flex items-center justify-center ml-1 text-primary font-extrabold">
                <IoIosArrowDropdown />
              </span>
            </button> */}
          {/* </div> */}
        </div>
        <div className="flex items-center md:hidden px-4 lg:hidden border border-[#FF6B00] rounded-lg">
          {/* Input field and styling based on expansion */}
          {/* {isExpanded && ( */}
          <input
            // ref={inputRef}
            onKeyPress={handleKeyPress}
            onChange={handleInputChange}
            type="text"
            placeholder="Search by ID..."
            className="text-xs md:text-sm lg:text-sm w-full h-7 outline-none rounded-l-md"
          />
          {/* )} */}
          {/* Search Icon (Hidden on larger screens) */}
          {/* <div
            className="md:hidden lg:hidden flex items-center justify-center w-7 h-6 cursor-pointer"
            onClick={handleSearchClick}
          > */}
          <AiOutlineSearch className="text-lg text-[#FF6B00]" />
          {/* </div> */}
        </div>
        {UserStore.loader ? (
          <>
            <table>
              <thead className="bg-[#FEEFD6]  h-14 rounded-lg">
                <tr className=" md:table-row lg:table-row">
                  {/* <th className="py-2 text-center font-medium rounded-s-xl text-[#121212] text-sm md:text-base">
                  Name
                </th> */}
                  <th className="py-2 font-medium text-sm md:text-base">
                    Date
                  </th>
                  <th className="py-2 font-medium text-sm md:text-base">
                    Transaction ID
                  </th>
                  <th className="py-2 font-medium text-sm md:text-base">
                    Credit Usage
                  </th>
                  <th className="py-2 font-medium text-sm md:text-base">
                    Reason
                  </th>
                  <th className="py-2 font-medium rounded-r-lg text-sm md:text-base">
                    Status
                  </th>
                </tr>
              </thead>
              <tbody>
                {Array.from({ length: shimmer.numRows }).map((_, index) => (
                  <tr
                    key={index}
                    className={`${shimmer.bgColor} animate-pulse border-b text-center justify-center md:h-fit lg:h-fit h-[20vh] text-[#717171] px-5 text-sm md:text-base`}
                    style={{ height: shimmer.rowHeight }}
                  >
                    {Array.from({ length: 5 }).map((_, idx) => (
                      <td key={idx} className="py-3 px-2">
                        <div
                          className={`bg-gray-300 rounded-md mx-2 animate-pulse`}
                          style={{ width: "100px", height: "20px" }}
                        ></div>
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </>
        ) : (
          <Table data={UserStore?.transactions} />
        )}
      </div>
    </>
  ));
};

export default ViewCredits;
